import { render, staticRenderFns } from "./zdyrbzuzhuang.vue?vue&type=template&id=64f62920&scoped=true&"
import script from "./zdyrbzuzhuang.vue?vue&type=script&lang=js&"
export * from "./zdyrbzuzhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f62920",
  null
  
)

export default component.exports